import { render, staticRenderFns } from "./VolumeSlider.vue?vue&type=template&id=38577e2a&scoped=true&"
import script from "./VolumeSlider.vue?vue&type=script&lang=js&"
export * from "./VolumeSlider.vue?vue&type=script&lang=js&"
import style0 from "./VolumeSlider.vue?vue&type=style&index=0&id=38577e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38577e2a",
  null
  
)

export default component.exports